import { useEffect } from 'react';

import styles from './ManagementAccounts.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DocumentUploadSection from '../components/DocumentUploadSection/DocumentUploadSection';

const DOCUMENT_TYPE = 'management accounts';

type TProps = {
  isActive: boolean;
  isError?: boolean;
  onRequestUpload: () => void;
};

const ManagementAccounts = ({ isActive, isError, onRequestUpload }: TProps) => {
  const stateKey = useContextStateKey();

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  const { documents } = useGetDocuments(stateKey);

  useEffect(() => {
    if (documents) {
      const managementAccountsDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(managementAccountsDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      {isActive && (
        <p>
          These could be whatever your business uses to aid forecasting,
          spending and budgeting.
        </p>
      )}
      <DocumentUploadSection
        documentType={DOCUMENT_TYPE}
        listOfInstructions={[]}
        uploadedFiles={uploadedFiles}
        isActive={isActive}
        isError={isError}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
        removeFile={removeFile}
        onRequestUpload={onRequestUpload}
      />
    </div>
  );
};

export default ManagementAccounts;
